import ProjectServiceDescription from './ServiceDescription/ProjectServiceDescription';
export { ProjectServiceDescription as Partner };